/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/creditcard/CreditCardScannerScreenTextLocalization.yaml
/**
Configuration of the all strings for credit card scanner screen.
*/
export class CreditCardScannerScreenTextLocalization {
    /** @param source {@displayType `DeepPartial<CreditCardScannerScreenTextLocalization>`} */
    constructor(source = {}) {
        /**
          Title for the top bar.
          
          Default is "Credit Card Scanner"
          */
        this.topBarTitle = 'Credit Card Scanner';
        /**
          Cancel button text for the top bar.
          
          Default is "Cancel"
          */
        this.topBarCancelButton = 'Cancel';
        /**
          Text for the top user guidance caption.
          
          Default is "Scan the credit card"
          */
        this.topUserGuidance = 'Scan the credit card';
        /**
          Title for the introduction screen.
          
          Default is "How to scan a credit card"
          */
        this.introScreenTitle = 'How to scan a credit card';
        /**
          Start scanning button text for the introduction screen.
          
          Default is "Start Scanning"
          */
        this.introScreenDoneButton = 'Start Scanning';
        /**
          The text explanation of the introduction screen.
          
          Default is "To quickly and securely input your credit card details, please hold your device over the credit card, so that the camera aligns with the numbers on the front of the card. \n\nThe scanner will guide you to the optimal scanning position. Once the scan is complete, your card details will automatically be extracted and processed.\n\nPress 'Start Scanning' to begin."
          */
        this.introScreenText = "To quickly and securely input your credit card details, please hold your device over the credit card, so that the camera aligns with the numbers on the front of the card. \n\nThe scanner will guide you to the optimal scanning position. Once the scan is complete, your card details will automatically be extracted and processed.\n\nPress 'Start Scanning' to begin.";
        /**
          Caption for the success overlay.
          
          Default is "Scanned successfully"
          */
        this.completionOverlaySuccessMessage = 'Scanned successfully';
        /**
          Caption for the success overlay when not all data from the card was scanned.
          
          Default is "Incomplete scan"
          */
        this.completionOverlayIncompleteDataMessage = 'Incomplete scan';
        /**
          Accessibility description for the 'open introduction screen' button in top bar.
          
          Default is "Open introduction screen."
          */
        this.accessibilityDescriptionOpenIntroScreenButton = 'Open introduction screen.';
        /**
          Accessibility description for the 'done'/'start scanning' button in the introduction screen.
          
          Default is "Start scanning"
          */
        this.accessibilityDescriptionIntroScreenDoneButton = 'Start scanning';
        /**
          Accessibility description for the 'cancel' button in the top bar.
          
          Default is "Cancel"
          */
        this.accessibilityDescriptionCancelButton = 'Cancel';
        /**
          Accessibility description for the flash button.
          
          Default is "Toggle flash"
          */
        this.accessibilityDescriptionFlashButton = 'Toggle flash';
        /**
          Accessibility value for the flash on button.
          
          Default is "On"
          */
        this.accessibilityStateFlashOnButton = 'On';
        /**
          Accessibility value for the flash off button.
          
          Default is "Off"
          */
        this.accessibilityStateFlashOffButton = 'Off';
        /**
          Accessibility description for the zoom button.
          
          Default is "Toggle camera zoom"
          */
        this.accessibilityDescriptionZoomButton = 'Toggle camera zoom';
        /**
          Accessibility description for the flip camera button.
          
          Default is "Flip camera"
          */
        this.accessibilityDescriptionFlipCameraButton = 'Flip camera';
        /**
          Accessibility value for the flip camera back button.
          
          Default is "Back"
          */
        this.accessibilityStateFlipCameraBackButton = 'Back';
        /**
          Accessibility value for the flip camera front button.
          
          Default is "Front"
          */
        this.accessibilityStateFlipCameraFrontButton = 'Front';
        /**
          The user guidance text displayed when no credit card is found.
          
          Default is "Looking for credit card..."
          */
        this.creditCardUserGuidanceNoCardFound = 'Looking for credit card...';
        /**
          The user guidance text displayed when a card presence was detected.
          
          Default is "Scanning the credit card..."
          */
        this.creditCardUserGuidanceScanningProgress = 'Scanning the credit card...';
        /**
          The user guidance text displayed when it is too dark to capture an adequate image.
          
          Default is "Too dark. Please turn on a light."
          */
        this.creditCardUserGuidanceTooDark = 'Too dark. Please turn on a light.';
        /**
          The user guidance text displayed when the detected card is too far away and appears too small.
          
          Default is "Please move closer to the credit card."
          */
        this.creditCardUserGuidanceTooSmall = 'Please move closer to the credit card.';
        /**
          The user guidance text displayed when the detected card is not in a good perspective (device tilted).
          
          Default is "Please hold your device straight over the credit card."
          */
        this.creditCardUserGuidanceBadPerspective = 'Please hold your device straight over the credit card.';
        /**
          The title of the camera permission dialog.
          
          Default is "Camera permission denied!"
          */
        this.cameraPermissionEnableCameraTitle = 'Camera permission denied!';
        /**
          The explanation text of the camera permission dialog.
          
          Default is "Please allow the usage of the camera to start the scanning process."
          */
        this.cameraPermissionEnableCameraExplanation = 'Please allow the usage of the camera to start the scanning process.';
        /**
          The 'enable' button title of the camera permission dialog.
          
          Default is "Grant permission"
          */
        this.cameraPermissionEnableCameraButton = 'Grant permission';
        /**
          The 'close' button title of the camera permission dialog.
          
          Default is "Close"
          */
        this.cameraPermissionCloseButton = 'Close';
        /**
          The accessibility hint for the 'enable' button of the camera permission dialog.
          
          Default is "Tap to grant camera permission"
          */
        this.accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
        /**
          The accessibility hint for the 'close' button of the camera permission dialog.
          
          Default is "Close screen without granting permission"
          */
        this.accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = source.topBarTitle;
        }
        if (source.topBarCancelButton !== undefined) {
            this.topBarCancelButton = source.topBarCancelButton;
        }
        if (source.topUserGuidance !== undefined) {
            this.topUserGuidance = source.topUserGuidance;
        }
        if (source.introScreenTitle !== undefined) {
            this.introScreenTitle = source.introScreenTitle;
        }
        if (source.introScreenDoneButton !== undefined) {
            this.introScreenDoneButton = source.introScreenDoneButton;
        }
        if (source.introScreenText !== undefined) {
            this.introScreenText = source.introScreenText;
        }
        if (source.completionOverlaySuccessMessage !== undefined) {
            this.completionOverlaySuccessMessage = source.completionOverlaySuccessMessage;
        }
        if (source.completionOverlayIncompleteDataMessage !== undefined) {
            this.completionOverlayIncompleteDataMessage = source.completionOverlayIncompleteDataMessage;
        }
        if (source.accessibilityDescriptionOpenIntroScreenButton !== undefined) {
            this.accessibilityDescriptionOpenIntroScreenButton = source.accessibilityDescriptionOpenIntroScreenButton;
        }
        if (source.accessibilityDescriptionIntroScreenDoneButton !== undefined) {
            this.accessibilityDescriptionIntroScreenDoneButton = source.accessibilityDescriptionIntroScreenDoneButton;
        }
        if (source.accessibilityDescriptionCancelButton !== undefined) {
            this.accessibilityDescriptionCancelButton = source.accessibilityDescriptionCancelButton;
        }
        if (source.accessibilityDescriptionFlashButton !== undefined) {
            this.accessibilityDescriptionFlashButton = source.accessibilityDescriptionFlashButton;
        }
        if (source.accessibilityStateFlashOnButton !== undefined) {
            this.accessibilityStateFlashOnButton = source.accessibilityStateFlashOnButton;
        }
        if (source.accessibilityStateFlashOffButton !== undefined) {
            this.accessibilityStateFlashOffButton = source.accessibilityStateFlashOffButton;
        }
        if (source.accessibilityDescriptionZoomButton !== undefined) {
            this.accessibilityDescriptionZoomButton = source.accessibilityDescriptionZoomButton;
        }
        if (source.accessibilityDescriptionFlipCameraButton !== undefined) {
            this.accessibilityDescriptionFlipCameraButton = source.accessibilityDescriptionFlipCameraButton;
        }
        if (source.accessibilityStateFlipCameraBackButton !== undefined) {
            this.accessibilityStateFlipCameraBackButton = source.accessibilityStateFlipCameraBackButton;
        }
        if (source.accessibilityStateFlipCameraFrontButton !== undefined) {
            this.accessibilityStateFlipCameraFrontButton = source.accessibilityStateFlipCameraFrontButton;
        }
        if (source.creditCardUserGuidanceNoCardFound !== undefined) {
            this.creditCardUserGuidanceNoCardFound = source.creditCardUserGuidanceNoCardFound;
        }
        if (source.creditCardUserGuidanceScanningProgress !== undefined) {
            this.creditCardUserGuidanceScanningProgress = source.creditCardUserGuidanceScanningProgress;
        }
        if (source.creditCardUserGuidanceTooDark !== undefined) {
            this.creditCardUserGuidanceTooDark = source.creditCardUserGuidanceTooDark;
        }
        if (source.creditCardUserGuidanceTooSmall !== undefined) {
            this.creditCardUserGuidanceTooSmall = source.creditCardUserGuidanceTooSmall;
        }
        if (source.creditCardUserGuidanceBadPerspective !== undefined) {
            this.creditCardUserGuidanceBadPerspective = source.creditCardUserGuidanceBadPerspective;
        }
        if (source.cameraPermissionEnableCameraTitle !== undefined) {
            this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
        }
        if (source.cameraPermissionEnableCameraExplanation !== undefined) {
            this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
        }
        if (source.cameraPermissionEnableCameraButton !== undefined) {
            this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
        }
        if (source.cameraPermissionCloseButton !== undefined) {
            this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
        }
        if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionEnableCameraButton =
                source.accessibilityDescriptionCameraPermissionEnableCameraButton;
        }
        if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionCloseButton =
                source.accessibilityDescriptionCameraPermissionCloseButton;
        }
    }
}
//# sourceMappingURL=CreditCardScannerScreenTextLocalization.js.map